var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PowerPermission"},[_c('FieldSet',{attrs:{"label":_vm.label,"values":_vm.values,"fields":_vm.fields,"layout":_vm.layout,"validation":_vm.validation,"disabled":_vm.disabled,"path":_vm.path,"viewer":_vm.viewer},on:{"blur":_vm.handleBlur,"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }